/**
 * Бычковые — 3 видов.
 *
 * ⚠️ ПОМЕТКИ «── ГДЕ ВОДИТСЯ ──» ПЕРЕЕХАЛИ СЮДА ВМЕСТЕ С РЫБОЙ. Вторая сотня
 * набиралась по краям света, и в прежнем файле виды стояли блоками: Иберия,
 * Балканы, Восточная Азия. Разрез по семействам эти блоки разнёс бы по
 * девятнадцати файлам, и знание о том, откуда вид, пропало бы вовсе — в коде
 * его больше нигде нет. Поэтому пометка идёт за своей рыбой.
 */
export const БЫЧКОВЫЕ = [
    // ── Наши воды ──
    {
        id: 'round_goby',
        семейство: 'бычковые',
        latin: 'Neogobius melanostomus',
        повадка: 'мелочь',
        minKg: 0.02,
        maxKg: 0.35,
        typicalKg: 0.08,
        typicalLengthM: 0.14,
        depthM: 3,
        depthBandM: 2,
        сложение: 'округлое',
        пасть: 'кожистая',
        редкость: 'массовая',
        когда: 'дневная',
        вода: { мин: 6, опт: 20, макс: 28 },
        течение: 'слабое',
        держится: ['камни', 'твёрдое_дно', 'бровка'],
        стая: 'одиночка',
        нерест: { с: 4, по: 7 },
        чем: [
            { чем: 'червь', вес: 1 },
            { чем: 'резка', вес: 0.8 },
            { чем: 'ракушка', вес: 0.8 },
            { чем: 'рачок', вес: 0.6 },
            { чем: 'мясо', вес: 0.4 },
            { чем: 'jig', вес: 0.4 },
        ],
    },
    {
        id: 'sand_goby',
        семейство: 'бычковые',
        latin: 'Neogobius fluviatilis',
        повадка: 'мелочь',
        minKg: 0.01,
        maxKg: 0.2,
        typicalKg: 0.05,
        typicalLengthM: 0.12,
        depthM: 2,
        depthBandM: 1.5,
        сложение: 'округлое',
        пасть: 'кожистая',
        редкость: 'обычная',
        когда: 'дневная',
        вода: { мин: 8, опт: 22, макс: 29 },
        течение: 'слабое',
        держится: ['твёрдое_дно', 'трава', 'бровка'],
        стая: 'одиночка',
        нерест: { с: 5, по: 7 },
        чем: [
            { чем: 'червь', вес: 1 },
            { чем: 'рачок', вес: 0.8 },
            { чем: 'резка', вес: 0.6 },
            { чем: 'ракушка', вес: 0.6 },
            { чем: 'мотыль', вес: 0.4 },
            { чем: 'jig', вес: 0.2 },
        ],
    },
    {
        id: 'tubenose_goby',
        семейство: 'бычковые',
        latin: 'Proterorhinus marmoratus',
        повадка: 'мелочь',
        minKg: 0.005,
        maxKg: 0.05,
        typicalKg: 0.015,
        typicalLengthM: 0.08,
        depthM: 1.5,
        depthBandM: 1,
        сложение: 'округлое',
        пасть: 'кожистая',
        редкость: 'обычная',
        когда: 'дневная',
        вода: { мин: 8, опт: 22, макс: 30 },
        течение: 'стоячая',
        держится: ['трава', 'ил', 'коряги'],
        стая: 'одиночка',
        нерест: { с: 5, по: 7 },
        чем: [
            { чем: 'мотыль', вес: 1 },
            { чем: 'червь', вес: 0.8 },
            { чем: 'опарыш', вес: 0.4 },
            { чем: 'рачок', вес: 0.4 },
        ],
    },
];
//# sourceMappingURL=gobiids.js.map